import React, { Component } from 'react';
import { compose } from 'recompose';
import AddressForm, { WithTitle } from '../../Common/AddressForm';
import AddressDataLayer from '../../Common/AddressDataLayer';
import { HTMLTrans } from '../../Common/Translations';
import { withValidateShippingAddress } from './ValidateShippingAddress';

class ShippingAddressForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      oldAddress: null,
    };
  }

  render() {
    const {
      onSave = () => {},
      onCancel = () => {},
      areAddressDetailsValid,
      methods,
      suggestedPostalCodeCombination = null,
      addressValidationErrors = null,
      ...otherProps
    } = this.props;

    if(this.state.oldAddress == null && this.props.address)
      this.setState({ oldAddress: this.props.address });

    return (
      <AddressDataLayer {...otherProps}>
        {(state, data, onChange) => (
          <div className="w-100">
            <AddressForm
              {...state.address}
              {...state}
              states={data.states[state.address.country_code]}
              cities={data.cities[state.address.state]}
              countries={data.countries}
              onChange={onChange}
              areAddressDetailsValid={areAddressDetailsValid}
              suggestedPostalCodeCombination={suggestedPostalCodeCombination}
              addressValidationErrors={addressValidationErrors}
            />
            {this.props.children}
            <div className='container d-flex justify-content-center justify-content-lg-end'>
              <a
                href="javascript:void(0);"
                onClick={onCancel}
                className='btn btn-outline-primary mr-3'>
                <HTMLTrans id="address.shippingaddressform_cancel_btn">Cancel</HTMLTrans>
              </a>
              <button type="button"
                onClick={async () => {
                  if (state.valid) {
                    let addressModified = false;
                    if(this.state.oldAddress) {
                      for (let key in state.address) {
                        if ((this.state.oldAddress[key] || "") != state.address[key]) {
                          addressModified = true;
                          this.setState({ oldAddress: state.address });
                          break;
                        }
                      }  
                    }
                    if(!this.props.areAddressDetailsValid && !addressModified) {
                      methods.updateState({ 
                        areAddressDetailsValid: true,
                        suggestedPostalCodeCombination: null,
                        addressValidationErrors: null });
                      onSave.bind(null, state.address)();
                    }
                    else {
                      let addressValidation = await this.props.validateShippingAddress(state.address);
                      if(addressValidation.success) {
                        methods.updateState({ 
                          areAddressDetailsValid: true,
                          suggestedPostalCodeCombination: null,
                          addressValidationErrors: null });
                        onSave.bind(null, state.address)();
                      }
                      else {
                        if (addressModified || state.id === "newAddress") {
                          methods.updateState({ 
                            areAddressDetailsValid: false,
                            suggestedPostalCodeCombination : addressValidation.data,
                            addressValidationErrors: addressValidation.errors });
                          this.setState({ oldAddress: state.address });
                        }
                        else if (!addressModified) {
                          methods.updateState({ 
                            areAddressDetailsValid: true,
                            suggestedPostalCodeCombination: null,
                            addressValidationErrors: null });
                          onSave.bind(null, state.address)();
                        }
                      }
                    }
                  } else onChange({ containerClass: 'was-validated' })
                }}
                className="btn btn-primary">
                <HTMLTrans id="address.shippingaddressform_save_btn">Save</HTMLTrans>
              </button>
            </div>
            <div className='col-4 d-lg-none'></div>
          </div>
        )}
      </AddressDataLayer>
    );
  }
}

const enhance = compose(
  WithTitle,
  withValidateShippingAddress
)

export const undecorated = ShippingAddressForm;
export default enhance(ShippingAddressForm);



// WEBPACK FOOTER //
// ./src/Checkout/ShippingAndPayment/ShippingAddressForm.js